export type { TrailListItemProps } from "./trail-list-item";
export { TrailListItem } from "./trail-list-item";
